import { FC } from 'react';
import { Controller, ControllerProps } from 'react-hook-form';
import { DateRangePicker, IDateRangePicker } from '../../datePicker/dateRangePicker.component.tsx';

export const FormDateRangePicker: FC<IFormDatePicker> = ({ name, onChange, onBlur, ...props }) => {
  return (
    <Controller
      name={name}
      render={({
        field: { value, onChange: onFieldChange, onBlur: onFieldBlur, ...restFields },
      }) => {
        return (
          <DateRangePicker
            {...props}
            value={value}
            onChange={(e) => {
              onFieldChange(e);
              onChange?.(e);
            }}
            onBlur={(e) => {
              onFieldBlur();
              onBlur?.(e);
            }}
            {...restFields}
          />
        );
      }}
    />
  );
};

interface IFormDatePicker extends Omit<IDateRangePicker, 'defaultValue' | 'value'> {
  name: ControllerProps['name'];
}
